import ActivityLog from "./components/ActivityLog";

export default ActivityLog;
